// design-system/Organisms/DefyMedicalBenefitsSection.tsx
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import { BenefitCard } from "@/design-system/Molecules";
import { Typography } from "@/design-system/Atoms";
import { benefits } from "@/design-system/Organisms/DefyMedicalBenefitsSection/benefits.data";

const DefyMedicalBenefitsSection = () => {
    return (
        <section
            className="relative block w-full h-full py-[75px] lg:py-[160px] mt-40 overflow-hidden bg-[#f6f6f4] 
            bg-[url('/images/bg-shape-2.svg')] bg-cover 
            bg-no-repeat 
            bg-center 
            rounded-t-[60px] 
            border-b-[12px] 
          border-[#d1f99c]">
            <div className="container px-4 mx-auto">
                <div className="flex flex-col lg:flex-row">
                    <div className="lg:w-5/12">
                        <Typography variant="categoryText" as="div" className="mb-[3.125rem]">
                            Defy Medical Benefits
                        </Typography>
                        <Typography variant="sectionHeading" as="h2" className="mb-3">
                            <>
                                Your Expert <span className="text-gray-400">Men’s Health Clinic</span>
                            </>
                        </Typography>
                    </div>
                    <div className="lg:w-7/12 relative">

                        <div className="absolute inset-0 swiper-controls hidden lg:flex lg:justify-end gap-12 ">
                            <div
                                className="!relative swiper-button-prev !mt-4 !w-[80px] !h-[60px] bg-[url('/images/slider-arrow-prev.svg')] bg-center bg-no-repeat bg-contain hover:rounded-md hover:shadow-[0_0_0_4px_#d6d9e1] transition-all duration-300 cursor-pointer"
                                role="button"
                                tabIndex={0}
                            />
                            <div
                                className="!relative swiper-button-next !mt-4 !w-[80px] !h-[60px] bg-[url('/images/slider-arrow-next.svg')] bg-center bg-no-repeat bg-contain hover:rounded-md hover:shadow-[0_0_0_4px_#d6d9e1] transition-all duration-300 cursor-pointer"
                                role="button"
                                tabIndex={0}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="px-0 mt-16">
                <div className="pl-4 md:pl-[calc((100%-720px)/2)] lg:pl-[calc((100%-960px)/2)] xl:pl-[calc((100%-1140px)/2)] 2xl:pl-[calc((100%-1320px)/2)]">
                    <Swiper
                        modules={[Navigation, Pagination]}
                        navigation={{
                            nextEl: ".swiper-button-next",
                            prevEl: ".swiper-button-prev",
                        }}
                        pagination={{ el: ".swiper-pagination", clickable: true }}
                        spaceBetween={20}
                        slidesPerView={1.2}
                        breakpoints={{
                            480: { slidesPerView: 1.2 },
                            576: { slidesPerView: 1.3 },
                            768: { slidesPerView: 1.5 },
                            992: { slidesPerView: 2.5 },
                            1200: { slidesPerView: 3.5 },
                        }}
                        className="mySwiper benefit-slider px-4"
                    >
                        {benefits.map((item, index) => (
                            <SwiperSlide key={index}>
                                <BenefitCard {...item} />
                            </SwiperSlide>

                        ))}
                    </Swiper>
                </div>
            </div>
        </section>
    );
};

export default DefyMedicalBenefitsSection;
